import connectQueryRules from '../connectors/connectQueryRules';
export default connectQueryRules(function QueryRuleContext() {
  return null;
});